/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ProductFormDeatil/index.tsx
 * @Description: 商品详情主体表单数据展示
 */
import styles from './index.module.scss';
import ProductImgPreview from './ProductImgPreview';
import ProductDetailMmuRight from './ProductDetailMmuRight';
import type { IProductDetail } from '../../product';

interface IProps {
  info: IProductDetail;
  shopId: any;
}

const ProductFormDetail = ({ info, shopId }: IProps) => {
  const isGreenProduct = !!info.serviceProductTag?.find((tag) => {
    return tag.tagName.includes('绿色');
  });
  return (
    <div className={styles.product_detail}>
      <ProductImgPreview
        isGreenProduct={isGreenProduct}
        imageProductTag={info?.imageProductTag}
        imgPaths={info?.imgPaths}
      />
      <ProductDetailMmuRight skuDetail={info} shopId={shopId} />
    </div>
  );
};

export default ProductFormDetail;
